import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

// eslint-disable-next-line import/prefer-default-export
export async function activateAccount(usernameEmail) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
    isPublic: true,
  };

  const activationPayload = {
    activation_status: true,
    notification: true,
    username_email: usernameEmail,
    user_activation: true,
  };
  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/xened/onboard/api/v1/activating/user`,
      activationPayload,
      requestConfig,
    );
  return data;
}
